import Cookies from 'js-cookie';
import FetchData from '../Components/ServerCall/FetchData';
import { IGroupList, IParticipantListOfGroup } from './types';

/**
 *
 * @returns an object with isError, message and data keys according to response status.
 * for success status, data is list of all groups.
 */
export async function getGroupsList() {
  const response = await FetchData({
    requestType: 'noData',
    method: 'GET',
    url: 'groups/list',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`,
      // "X-TENANT-ID": "silzila",
    },
  });
  if (!response.status) {
    return {
      isError: true,
      message: (response.error ??
        'Error while getting Groups list') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Group list retrieved successfully',
    data: response.data as IGroupList[],
  };
}

/**
 * @param newGroupName      name of new group
 */
export async function createGroup(newGroupName: string) {
  const response = await FetchData({
    requestType: 'noData',
    method: 'POST',
    url: `groups/${newGroupName}`,
    headers: {
      Authorization: `Bearer ${Cookies.get('authToken')}`,
      'Content-Type': 'application/json',
    },
  });
  if (!response.status) {
    return {
      isError: true,
      message: (response.error ?? 'Error while creating Group') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Group created successfully',
    data: response.data as string,
  };
}

/**
 * @param id     unique id of a group
 */
export async function deleteGroup(id: string) {
  const response = await FetchData({
    requestType: 'noData',
    method: 'DELETE',
    url: `groups/${id}`,
    headers: {
      Authorization: `Bearer ${Cookies.get('authToken')}`,
      // "X-TENANT-ID": "silzila",
      'Content-Type': 'application/json',
    },
  });
  if (!response.status) {
    return {
      isError: true,
      message: (response.error ?? 'Error while deleting Group') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Group deleted successfully',
    data: response.data as string,
  };
}

export async function updateGroupName(id: string, newGroupName: string) {
  const response = await FetchData({
    requestType: 'withData',
    method: 'PUT',
    url: 'groups/update',
    headers: {
      Authorization: `Bearer ${Cookies.get('authToken')}`,
      'Content-Type': 'application/json',
    },
    data: {
      id: id,
      name: newGroupName,
    },
  });
  if (!response.status) {
    return {
      isError: true,
      message: (response.error ??
        `Falied to update group name ${newGroupName}`) as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'Group deleted successfully',
    data: response.data as string,
  };
}

/**
 *
 * @param id     unique id of a group
 * @returns an object with isError, message and data keys according to response status.
 * for success status, data is list of all participants/users in a group.
 */
export async function getAllPartcipants(id: string) {
  const response = await FetchData({
    requestType: 'noData',
    method: 'GET',
    url: `groups/list/${id}`,
    headers: {
      Authorization: `Bearer ${Cookies.get('authToken')}`,
      'Content-Type': 'application/json',
    },
  });
  if (!response.status) {
    return {
      isError: true,
      message: (response.error ??
        'Error while getting participants') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: "Group's participants fetched successfully",
    data: response.data as IParticipantListOfGroup[],
  };
}

/**
 *
 * @param userIds  unique id of user
 * @param groupId  unique id of group
 * @returns an object with isError, message and data keys according to response status.
 */
export async function addUsersInAGroup(userIds: any, groupId: string) {
  const response = await FetchData({
    requestType: 'withData', // No data returned in the response
    method: 'POST', // HTTP method
    url: 'groups/adduser', // API endpoint
    data: {
      userIds: userIds,
      groupId: groupId,
    },
    headers: {
      Authorization: `Bearer ${Cookies.get('authToken')}`,
      // "X-TENANT-ID": "silzila",
      'Content-Type': 'application/json',
    },
  });
  if (!response.status) {
    return {
      isError: true,
      message: (response.error ??
        'Error while adding users to group') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'User(s) added successfully!',
    data: response.data as string,
  };
}

/**
 *
 * @param Userid       unique id of user
 * @param groupId      unique id of group
 * @returns an object with isError, message and data keys according to response status.
 */
export async function removeUserFromGroup(userid: string, groupId: string) {
  const response = await FetchData({
    requestType: 'withData',
    method: 'DELETE',
    url: 'groups/removeuser',
    data: {
      userIds: [userid],
      groupId: groupId,
    },
    headers: {
      Authorization: `Bearer ${Cookies.get('authToken')}`,
      // "X-TENANT-ID": "silzila",
      'Content-Type': 'application/json',
    },
  });
  if (!response.status) {
    return {
      isError: true,
      message: (response.error ??
        'Error while removing user from group') as string,
      data: null,
    };
  }
  return {
    isError: false,
    message: 'User removed successfully!',
    data: response.data as string,
  };
}
